import { Grid, Box, Stack, Button, CircularProgress } from '@mui/material';
import { memo, useContext } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { EditableContext } from '../../contexts/EditableContext';

type Props = {
  onSave: () => void | Promise<void>;
  onDelete: () => void;
  disabled: boolean;
  saving?: boolean;
};

const SaveAndDeleteButtons = memo(({ onSave, onDelete, disabled, saving }: Props) => {
  const isEditable = useContext(EditableContext);

  return (!isEditable ? <></> :
    <Grid item xs={6}>
      <Box display="flex" justifyContent="flex-end" className="tools">
        <Stack spacing={2} direction="row">
          <Button
            variant="contained"
            color="primary"
            onClick={onSave}
            disabled={disabled || !!saving}
            endIcon={saving ? <CircularProgress size={16} /> : <SaveIcon />}
          >
            {saving ? 'Saving…' : 'Save Placeholder'}
          </Button>
          <Button color="error" onClick={onDelete} disabled={!!saving}>
            Delete <DeleteIcon />
          </Button>
        </Stack>
      </Box>
    </Grid>
  );
});

export default SaveAndDeleteButtons;